import { render, staticRenderFns } from "./CommonQuestionsResale.vue?vue&type=template&id=0d352471&scoped=true"
import script from "./CommonQuestionsResale.vue?vue&type=script&lang=js"
export * from "./CommonQuestionsResale.vue?vue&type=script&lang=js"
import style0 from "./CommonQuestionsResale.vue?vue&type=style&index=0&id=0d352471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d352471",
  null
  
)

export default component.exports